enum BreakPoint {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}

interface MediaQuery {
  minWidth: {
    xs: string;
    sm: string;
    md: string;
    lg: string;
  };
  inputDevice: {
    mouse: string;
  };
}

export const breakpoints: Record<BreakPoint, string> = {
  xs: '375px',
  sm: '768px',
  md: '920px',
  lg: '1150px',
};

const content: (properties: string) => string = (properties) => `(${properties})`;

const media: (content: string) => string = (queryContent) => `@media ${queryContent}`;

const mouse = media(`${content('hover: hover')} and ${content('pointer: fine')}`);

const width: (breakpoint: BreakPoint) => string = (breakpoint: BreakPoint) =>
  media(content(`min-width: ${breakpoints[breakpoint]}`));

export const mediaQuery: MediaQuery = {
  minWidth: {
    xs: width(BreakPoint.xs),
    sm: width(BreakPoint.sm),
    md: width(BreakPoint.md),
    lg: width(BreakPoint.lg),
  },
  inputDevice: {
    mouse,
  },
};
